"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Messages = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_transition_group_1 = require("react-transition-group");
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var Message_1 = require("./Message");
var Overlay_1 = require("../Overlay");
var Typography_1 = require("../Typography");
/**
 * @internal
 */
exports.Messages = function (_a) {
    var _b = _a.messages, messages = _b === void 0 ? [] : _b, _c = _a.onMessageClose, onMessageClose = _c === void 0 ? noop_1.default : _c;
    var _d = tslib_1.__read(react_1.useState([]), 2), expandedMessageIds = _d[0], setExpandedMessageIds = _d[1];
    var handleMessageClose = react_1.useCallback(function (messageId) {
        setExpandedMessageIds(function (old) { return old.filter(function (expandedId) { return expandedId !== messageId; }); });
        onMessageClose(messageId);
    }, [onMessageClose]);
    return (react_1.default.createElement(Overlay_1.Overlay, null,
        react_1.default.createElement("div", { className: "gd-messages" },
            react_1.default.createElement(react_transition_group_1.TransitionGroup, null,
                react_1.default.createElement(react_transition_group_1.CSSTransition, { classNames: "gd-message", timeout: 220 },
                    react_1.default.createElement("div", null, messages.map(function (message) {
                        var id = message.id, component = message.component, showMore = message.showMore, type = message.type, contrast = message.contrast, intensive = message.intensive;
                        var isExpanded = expandedMessageIds.includes(message.id);
                        return (react_1.default.createElement("div", { key: id },
                            react_1.default.createElement(Message_1.Message, { className: classnames_1.default("gd-message-overlay", !showMore && "gd-message-overlay", showMore && "gd-message-overlay-custom"), type: type, onClose: function () { return handleMessageClose(id); }, contrast: contrast, intensive: intensive }, component || (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(MessageWithShowMore, { message: message, shouldShowMore: !isExpanded, handleShowMore: function () {
                                        if (isExpanded) {
                                            setExpandedMessageIds(function (old) {
                                                return old.filter(function (expandedId) { return expandedId !== id; });
                                            });
                                        }
                                        else {
                                            setExpandedMessageIds(function (old) { return tslib_1.__spread(old, [id]); });
                                        }
                                    } }),
                                react_1.default.createElement(MessageSimple, { message: message }))))));
                    })))))));
};
var MessageWithShowMore = function (_a) {
    var message = _a.message, shouldShowMore = _a.shouldShowMore, handleShowMore = _a.handleShowMore;
    var showMore = message.showMore, showLess = message.showLess, errorDetail = message.errorDetail, type = message.type;
    if (!showMore) {
        return null;
    }
    var contentClassNames = classnames_1.default("gd-message-text-content", "s-message-text-content", type, {
        off: shouldShowMore,
        on: !shouldShowMore,
    });
    var showMoreLinkClassNames = classnames_1.default("gd-message-text-showmorelink", "s-message-text-showmorelink", type);
    return (react_1.default.createElement("div", { className: "gd-message-text-showmore" },
        react_1.default.createElement(Typography_1.Typography, { tagName: "p", className: "gd-message-text-header" },
            react_1.default.createElement(MessageElement, { message: message, type: "span" }),
            react_1.default.createElement("span", { className: showMoreLinkClassNames, onClick: handleShowMore }, shouldShowMore ? showMore : showLess)),
        react_1.default.createElement("div", { className: contentClassNames }, errorDetail)));
};
var MessageSimple = function (_a) {
    var message = _a.message;
    var showMore = message.showMore;
    if (showMore) {
        return null;
    }
    return react_1.default.createElement(MessageElement, { message: message, type: "div" });
};
var MessageElement = function (_a) {
    var message = _a.message, type = _a.type;
    var text = message.text, node = message.node;
    var Component = type;
    if (node) {
        return react_1.default.createElement(Component, { className: "s-message-text-header-value" }, node);
    }
    return (react_1.default.createElement(Component, { className: "s-message-text-header-value", dangerouslySetInnerHTML: { __html: text || "" } }));
};
//# sourceMappingURL=Messages.js.map